import React from "react";
import PropTypes from "prop-types";
import { times } from "lodash";
import { getPropsFromData, RadioField } from "../../FormField";
import FamilyRecord from "./FamilyRecord";

const Family = ({ data }) => {
  return (
    <fieldset>
      <table className="hdf-form">
        <thead>
          <tr className="table-title">
            <th colSpan="5">B) FAMILY HISTORY OF PROPOSED EMPLOYEE / ELIGIBLE MEMBER</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="5">
              Has any of your parents or siblings died or suffered from cancer (specify type), heart
              diease, stroke, high blood pressure, diabetes, kidney disease, mental disorder,
              tuberculosis or any hereditary disease(s)?
              <br />
              <RadioField
                noDivWrapper={true}
                label="Yes"
                radioValue="Yes"
                noErrorMsg={true}
                {...getPropsFromData(data, "EmpFamilyHistory")}
              />
              <RadioField
                noDivWrapper={true}
                label="No"
                radioValue="No"
                {...getPropsFromData(data, "EmpFamilyHistory")}
              />
              <br />
              (If yes, please provide details below)
            </td>
          </tr>
          <tr className="text-center">
            <td colSpan="3">If Alive</td>
            <td colSpan="2">If Deceased</td>
          </tr>
          <tr className="text-center">
            <td width="25%">
              Relationship
              <br />
              (Father, mother, sister or brother)
            </td>
            <td width="25%">
              Please indicate type of Medical
              <br />
              Condition and the exact Diagnosis
            </td>
            <td width="15%">
              Age at time of
              <br />
              Diagnosis
            </td>
            <td width="10%">
              Age at
              <br />
              Death
            </td>
            <td width="20%">Cause of Death</td>
          </tr>
          {times(4, n => (
            <FamilyRecord data={data} index={n + 1} key={n} />
          ))}
        </tbody>
      </table>
    </fieldset>
  );
};

Family.propTypes = {
  data: PropTypes.object,
};

export default Family;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/Family.jsx